import { DeviceModelPortSpecificationOutputData } from './device-model-port-specification-output-data.model';


export class DeviceModelWithoutStatusOutput implements IDeviceModelWithoutStatusOutput {
    /** The auto-generated id of the device model  master */
    device_model_id!: number;
    /** The device model name with 255 character limit */
    device_name!: string;
    /** The device model protocol with 100 character limit */
    protocol!: string;
    /** The device model port with 100 character limit */
    port!: string;
    /** Manage status of device model. 0 For De-active, 1 For Active */
    status!: number;
    device_model_port_specification!: DeviceModelPortSpecificationOutputData[];

    constructor(data?: IDeviceModelWithoutStatusOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.device_model_id = _data["device_model_id"];
            this.device_name = _data["device_name"];
            this.protocol = _data["protocol"];
            this.port = _data["port"];
            this.status = _data["status"];
            if (Array.isArray(_data["device_model_port_specification"])) {
                this.device_model_port_specification = [] as any;
                for (let item of _data["device_model_port_specification"])
                    this.device_model_port_specification!.push(DeviceModelPortSpecificationOutputData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceModelWithoutStatusOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceModelWithoutStatusOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["device_model_id"] = this.device_model_id;
        data["device_name"] = this.device_name;
        data["protocol"] = this.protocol;
        data["port"] = this.port;
        data["status"] = this.status;
        if (Array.isArray(this.device_model_port_specification)) {
            data["device_model_port_specification"] = [];
            for (let item of this.device_model_port_specification)
                data["device_model_port_specification"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDeviceModelWithoutStatusOutput {
    /** The auto-generated id of the device model  master */
    device_model_id: number;
    /** The device model name with 255 character limit */
    device_name: string;
    /** The device model protocol with 100 character limit */
    protocol: string;
    /** The device model port with 100 character limit */
    port: string;
    /** Manage status of device model. 0 For De-active, 1 For Active */
    status: number;
    device_model_port_specification: DeviceModelPortSpecificationOutputData[];
}

